import * as at from './actions/actionTypes';

const initialState = {
  images: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case at.LOAD_MEDIA: {
      return {
        ...state,
        images: payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
